import chroma from 'chroma-js';
import { CreateColorVariantsValue } from './theme.types';
import { SHADE_LIGHTNESS } from './palette.constants';
import { isHexColor } from '@leverate/common-client';

const generatePaletteFromHex = (hex: string): CreateColorVariantsValue => {
    const [h, s] = chroma(hex).hsl();
    const result = {} as CreateColorVariantsValue;
    for (const [shade, lightness] of Object.entries(SHADE_LIGHTNESS)) {
        result[shade] = chroma.hsl(h || 0, s, lightness / 100).hex();
    }
    return result;
};

export const resolvePalette = (
    colorValue: string,
    predefined: Record<string, CreateColorVariantsValue>,
    fallback: CreateColorVariantsValue
): CreateColorVariantsValue => {
    if (isHexColor(colorValue)) return generatePaletteFromHex(colorValue);
    return predefined[colorValue] || fallback;
};
